import React from "react";
import { Trailer, useGetTrailersPaginatedWithSearchQuery } from "../../../api/trailersApi";
import TrailersTable from "./TrailersTable";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../../constants/dataTable";
import { useDataTablePagination } from "../../../hooks/useDataTablePagination";

const TrailerTab: React.FC = () => {
  const {
    items: trailers,
    isLoading,
    isLoadingRows,
    isLoadingMore,
    totalCount,
    hasNextPage,
    handleSearchChange,
    handleLoadMore,
  } = useDataTablePagination<Trailer>(
    useGetTrailersPaginatedWithSearchQuery,
    DEFAULT_DATA_TABLE_PAGE_SIZE
  );

  return (
    <TrailersTable
      trailers={trailers}
      isLoading={isLoading}
      totalCount={totalCount}
      hasNextPage={hasNextPage}
      isLoadingMore={isLoadingMore}
      isLoadingRows={isLoadingRows}
      onLoadMore={handleLoadMore}
      
      // Search functionality
      enableSearch={true}
      onSearchChange={handleSearchChange}
    />
  );
};

export default TrailerTab;